/**
 * 各业务方H5用户中心appid
 */
export const P_MALL_APPID = 'xp_ppstore'; // 商城H5

export const servicePhone = '4008193388'; // 客服电话

export const CHARGE_CDN = 'https://s.xiaopeng.com/xp-charge/mini'; // 充电CDN

export const HOME_PILE_SHARE_VERSION = '4.52.0'; // 私桩共享app上线版本号

// 环境判断
const UA = navigator.userAgent || '';
export const isXPApp = /xiaopeng/i.test(UA); // 小鹏app
export const isWX = /micromessenger/i.test(UA); // 微信
export const isWXApp = isWX && /miniProgram/i.test(UA); // 微信小程序
export const isMyApp = /AliApp/i.test(UA) && /miniProgram/i.test(UA); // 支付宝小程序

export const PILE_SHARING_FORM_KEY = 'pileSharingForm_v2';

export const MAP_COPYRIGHT_CODE = 'GS(2024)1158号';
